import { cva } from 'class-variance-authority';

import type { VariantProps } from 'class-variance-authority';

export const collapseVariants = cva('group/collapse', {
  variants: {
    variant: {
      default:
        'collapse-wrapper hover:ring-2 hover:ring-blue-500 group-active/collapse:border-blue-600',
      minimal: 'lg:border-t lg:border-t-gray-300',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type CollapseVariants = VariantProps<typeof collapseVariants>;
